module.exports = __webpack_public_path__ + "img/EDIbWLyb.e644873f.jpg";